import { DEFAULT_CATEGORIES } from "../config/appCategories";
import type { Category } from "./apps";

/**
 * Shared category options for Publish Your App and Discover Apps.
 * Prefer the live catalogue; fall back to the authoritative default catalog.
 */
export function resolveCategoryOptions(apiCategories: Category[]): Category[] {
  if (apiCategories.length > 0) {
    return apiCategories;
  }

  return DEFAULT_CATEGORIES.map((category, index) => ({
    id: `fallback-${index}`,
    name: category.name,
    slug: category.slug,
  }));
}
